











































































import {Component} from 'vue-property-decorator';

import Menu from '../components/Menu.vue';
import Footer from '@/components/Footer.vue';
import MainImage from '@/components/MainImage.vue';
import {Mixins} from 'vue-mixin-decorator';
import PageVue from '@/script/PageVue';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';

@Component({
  components: {MainImage, Footer, Menu },
})
export default class Announcement01Page extends Mixins<PageVue>(PageVue) {}
